import { render, staticRenderFns } from "./SignUpBanner.vue?vue&type=template&id=7c60dd25&scoped=true&"
import script from "./SignUpBanner.vue?vue&type=script&lang=js&"
export * from "./SignUpBanner.vue?vue&type=script&lang=js&"
import style0 from "./SignUpBanner.vue?vue&type=style&index=0&id=7c60dd25&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c60dd25",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/app/appsumo/nuxt/components/wishlists/Button.vue').default})
